export default {
  name: "",
  components: {},
  props: [],
  data() {
    return {
      isLoading: false,
      firstLoadDone: false,
      exists: false
    };
  },
  computed: {},

  async created() {
    await this.GetItem();
    this.firstLoadDone = true;
  },
  mounted() {},

  methods: {
    async GetItem() {
      try {
        let res = await this.$helpers.PostApi("get/licenseKeyExist", {});
        this.exists = res[0].exists;
      } catch (error) {}
    },

    async Generate() {
      this.isLoading = true;
      this.$helpers.ShowStatus(
        "Generating key... this can take a while",
        0,
        "info"
      );

      this.$helpers
        .PostApi("create/licenseKey", {})
        .then(res => {
          this.exists = true;
          this.isLoading = false;
          this.$helpers.ShowStatus(
            "Done. Ready for download.",
            10000,
            "success"
          );
        })
        .catch(err => {
          console.log(err);
          this.isLoading = false;
        });
    }
  }
};
